<template>
  <b-button
    class="button has-text-success whatsapp has-text-weight-semibold"
    tag="a"
    :title="title"
    icon-left="whatsapp"
    icon-pack="fab"
    size="is-medium"
    @click="prompt"
  >&nbsp; {{ title }}</b-button>
</template>

<script>
export default {
  methods: {
    prompt() {
      this.$buefy.dialog.prompt({
        message: `Enter Your Name`,
        inputAttrs: {
          placeholder: "ex: Mannan Dattah",
          maxlength: 20
        },
        title: "Book a Free Trial",
        confirmText: "Request",
        canCancel: true,
        type: "is-success",
        // hasIcon: true,
        // icon: "whatsapp",
        // iconPack: "fab",
        trapFocus: false,
        onConfirm: value =>
          window.open(
            `https://api.whatsapp.com/send?text=Hi.%20I%20am%20${value}.%20I%20want%20to%20know%20about%20MMA&phone=919810021011`,
            "_blank"
          )
      });
    }
  },
  props: {
    url: {
      type: String,
      default: "/signin"
    },
    title: {
      type: String,
      default: "Book a free Trial"
    }
  }
};
</script>

<style lang="scss" scoped>
.whatsapp {
  // font-size: 1rem !important;
  padding: 10px !important;
  border-radius: 5px;
  border: none;
  //  margin-right: -10px;
  background-color: rgba(30, 97, 39, 0.8);
}
</style>
